import AnalyticsSvg from '@/assets/images/icons/card-analytics.svg?inline';
import CarSvg from '@/assets/images/icons/card-car.svg?inline';
import DashboardSvg from '@/assets/images/icons/card-dashboard.svg?inline';
import HeadlampSvg from '@/assets/images/icons/card-headlamp.svg?inline';
import ModulesSvg from '@/assets/images/icons/card-module.svg?inline';
import PlusSvg from '@/assets/images/icons/card-plus.svg?inline';
import ProductsSvg from '@/assets/images/icons/card-products.svg?inline';
import RearLampSvg from '@/assets/images/icons/card-rear-lamp.svg?inline';
import SettingsSvg from '@/assets/images/icons/card-settings.svg?inline';

export const ICONS = [
  {
    id: 1,
    label: 'Analytics',
    component: AnalyticsSvg,
  },
  {
    id: 2,
    label: 'Car',
    component: CarSvg,
  },
  {
    id: 3,
    label: 'Dashboard',
    component: DashboardSvg,
  },
  {
    id: 4,
    label: 'Headlamp',
    component: HeadlampSvg,
  },
  {
    id: 5,
    label: 'Modules',
    component: ModulesSvg,
  },
  {
    id: 6,
    label: 'Plus',
    component: PlusSvg,
  },
  {
    id: 7,
    label: 'Products',
    component: ProductsSvg,
  },
  {
    id: 8,
    label: 'RearLamp',
    component: RearLampSvg,
  },
  {
    id: 9,
    label: 'Settings',
    component: SettingsSvg,
  },
];

export const ICON = ICONS.reduce((acc, icon) => ({
  ...acc,
  [icon.id]: icon,
}), {});
